import { render, staticRenderFns } from "./RegionalMaintenance.vue?vue&type=template&id=227fcf82&scoped=true&"
import script from "./RegionalMaintenance.vue?vue&type=script&lang=js&"
export * from "./RegionalMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./RegionalMaintenance.vue?vue&type=style&index=0&id=227fcf82&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227fcf82",
  null
  
)

export default component.exports